import { set } from '@/utils/vuex';
import { USER_DETAIL } from '@/store/modules/user/types';

export default {
  USER_DETAIL: set(USER_DETAIL),
};
